/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a 2- or 3-set Venn diagram from item lists — see overlaps and unique counts, no sign-up.`)
};

const es_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un diagrama de Venn de 2 o 3 conjuntos a partir de listas de elementos — ve superposiciones y recuentos únicos, sin registro.`)
};

const de_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle ein Venn-Diagramm mit 2 oder 3 Mengen aus Listen — sieh Überschneidungen und eindeutige Anzahlen, keine Anmeldung nötig.`)
};

const nl_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een Venn-diagram met 2 of 3 sets van itemlijsten — zie overlappingen en unieke aantallen, zonder aanmelding.`)
};

const fr_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un diagramme de Venn à 2 ou 3 ensembles à partir de listes d'éléments — visualisez les chevauchements et les décomptes uniques, sans inscription.`)
};

const it_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un diagramma di Venn a 2 o 3 insiemi da elenchi di elementi — vedi sovrapposizioni e conteggi unici, senza registrazione.`)
};

const pt_br2_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um diagrama de Venn de 2 ou 3 conjuntos a partir de listas de itens — veja sobreposições e contagens exclusivas, sem cadastro.`)
};

const pt_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um diagrama de Venn de 2 ou 3 conjuntos a partir de listas de itens — veja sobreposições e contagens únicas, sem registo.`)
};

const ja_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`項目リストから2集合または3集合のベン図を作成 — 重なりと固有の件数を確認、サインアップ不要。`)
};

const zh_venn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据项目列表创建 2 组或 3 组维恩图 — 查看重叠和唯一计数，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_tool_description", locale)
	if (locale === "en") return en_venn_tool_description(inputs)
	if (locale === "es") return es_venn_tool_description(inputs)
	if (locale === "de") return de_venn_tool_description(inputs)
	if (locale === "nl") return nl_venn_tool_description(inputs)
	if (locale === "fr") return fr_venn_tool_description(inputs)
	if (locale === "it") return it_venn_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_venn_tool_description(inputs)
	if (locale === "pt") return pt_venn_tool_description(inputs)
	if (locale === "ja") return ja_venn_tool_description(inputs)
	return zh_venn_tool_description(inputs)
};